import type { ReactNode } from "react";
import type { ProviderType } from "@wags/catalog/pure.ts";
import { Button } from "@wags/ui/button.tsx";
import { ListingProviderName } from "./listing-provider-name";

export function UnpricedListingSummary({
    name,
    breed,
    providerName,
    providerId,
    providerIsVerified,
    providerType,
    actions,
    primaryAction,
    contactHelp,
}: {
    name: string;
    breed?: string;
    providerName?: string;
    providerId?: string;
    providerIsVerified?: boolean;
    providerType: ProviderType;
    actions: ReactNode;
    contactHelp: (cta: ReactNode) => ReactNode;
    primaryAction?: {
        label: string;
        accessibleLabel: string;
        onClick: () => void;
    };
}) {
    return (
        <div className="relative z-10 md:mt-2">
            <h1 className="min-w-0 text-page-title text-doberman-black text-balance break-words">
                {name}
            </h1>
            <div className="mt-3 grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-4">
                <div className="min-w-0 pt-2.5">
                    {breed && (
                        <p className="text-body-small text-doberman-black/70 text-pretty">
                            {breed}
                        </p>
                    )}
                    {providerName && (
                        <div className="mt-1 break-words">
                            <ListingProviderName
                                name={providerName}
                                id={providerId}
                                isVerified={providerIsVerified}
                                providerType={providerType}
                            />
                        </div>
                    )}
                </div>
                <div className="flex shrink-0 items-center gap-2">
                    {actions}
                </div>
            </div>
            {primaryAction && (
                <div className="mt-6 md:mt-8">
                    {contactHelp(
                        <Button
                            type="button"
                            emphasis="lead"
                            size="primary-action"
                            className="w-full text-label"
                            aria-label={primaryAction.accessibleLabel}
                            onClick={primaryAction.onClick}
                        >
                            {primaryAction.label}
                        </Button>,
                    )}
                </div>
            )}
        </div>
    );
}
